<admin-app-header></admin-app-header>
<div class="container mt-5">
    <div class="row">
        <div class="col-md-8">
            <h1><i class="fas fa-credit-card me-2"></i>Test MOTO Token Payment</h1>
            <p class="text-muted">Process a small test charge against a client's vaulted card via the MOTO account. Max R10.00.</p>
            <hr />

            <!-- Step 1: Client lookup -->
            <div class="mb-4">
                <label class="form-label fw-bold">1. Select Client</label>
                <input
                    class="form-control"
                    placeholder="Start typing a client name..."
                    [typeahead]="clients"
                    [typeaheadOptionField]="'firstName'"
                    [typeaheadMinLength]="1"
                    (typeaheadOnSelect)="onClientSelect($event)"
                    [(ngModel)]="clientSearchText"
                >
                <ng-template #clientItemTemplate let-model="item">
                    {{ model.firstName }} {{ model.lastName }} — {{ model.email }}
                </ng-template>

                <div *ngIf="selectedClient" class="mt-2 alert alert-info mb-0">
                    <strong>{{ selectedClient.firstName }} {{ selectedClient.lastName }}</strong>
                    <span class="text-muted ms-2">{{ selectedClient.$key }}</span>
                </div>
            </div>

            <!-- Step 2: Card selection -->
            <div class="mb-4" *ngIf="selectedClient">
                <label class="form-label fw-bold">2. Select Card</label>
                <div *ngIf="!paymentMethodsLoaded" class="text-muted">Loading cards...</div>
                <div *ngIf="paymentMethodsLoaded && paymentMethods.length === 0" class="alert alert-warning">
                    No active payment methods found for this client.
                </div>
                <div *ngFor="let pm of paymentMethods"
                     class="card mb-2 p-2"
                     [class.border-primary]="selectedPaymentMethod?.$key === pm.$key"
                     (click)="selectCard(pm)"
                     style="cursor: pointer;">
                    <div class="d-flex align-items-center">
                        <input type="radio" class="form-check-input me-3"
                               [checked]="selectedPaymentMethod?.$key === pm.$key"
                               name="cardSelect">
                        <div>
                            <i class="fa-brands {{ pm.icon }} me-1"></i>
                            <strong>{{ pm.cardNo }}</strong>
                            <span class="text-muted ms-2">{{ pm.nameOnCard }}</span>
                            <span *ngIf="pm.primary" class="badge bg-success ms-2">Primary</span>
                        </div>
                        <div class="ms-auto">
                            <small class="text-muted">Vault: {{ pm.vaultId ? 'Yes' : 'No' }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 3: Amount -->
            <div class="mb-4" *ngIf="selectedPaymentMethod">
                <label class="form-label fw-bold">3. Amount (Rands)</label>
                <div class="input-group" style="max-width: 200px;">
                    <span class="input-group-text">R</span>
                    <input type="number" class="form-control" [(ngModel)]="amountRands"
                           min="0.01" max="10" step="0.01" placeholder="1.00">
                </div>
                <small class="text-muted">Minimum R0.01, maximum R10.00</small>
            </div>

            <!-- Submit -->
            <div class="mb-4" *ngIf="selectedPaymentMethod">
                <button class="btn btn-primary"
                        [disabled]="loading || !isAmountValid"
                        (click)="submitTestPayment()">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    <i *ngIf="!loading" class="fas fa-bolt me-1"></i>
                    Process Test Payment
                </button>
            </div>

            <!-- Result -->
            <div *ngIf="result" class="mb-4">
                <h5>Result</h5>
                <div class="alert" [ngClass]="result.error ? 'alert-danger' : 'alert-success'">
                    <strong>{{ result.error ? 'Failed' : 'Success' }}</strong>
                    <span *ngIf="result.message" class="ms-2">{{ result.message }}</span>
                </div>

                <div *ngIf="result.payGateResponse" class="card result-card">
                    <div class="card-header fw-bold">PayGate Response</div>
                    <div class="card-body">
                        <table class="table table-sm table-bordered mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-bold" style="width: 220px;">Status Name</td>
                                    <td>{{ result.payGateResponse.statusName || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Result Code</td>
                                    <td>{{ result.payGateResponse.resultCode || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Result Description</td>
                                    <td>{{ result.payGateResponse.resultDescription || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Transaction ID</td>
                                    <td>{{ result.payGateResponse.transactionId || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Transaction Status</td>
                                    <td>{{ result.payGateResponse.transactionStatusDescription || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Auth Code</td>
                                    <td>{{ result.payGateResponse.authCode || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Amount (cents)</td>
                                    <td>{{ result.payGateResponse.amount || '—' }}</td>
                                </tr>
                                <tr>
                                    <td class="fw-bold">Pay Request ID</td>
                                    <td>{{ result.payGateResponse.payRequestId || '—' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div *ngIf="result.payGateResponse" class="mt-3">
                    <a class="text-decoration-underline" style="cursor: pointer;" (click)="showRawJson = !showRawJson">
                        {{ showRawJson ? 'Hide' : 'Show' }} raw response
                    </a>
                    <pre *ngIf="showRawJson" class="mt-2 p-2 bg-light border rounded" style="max-height: 400px; overflow-y: auto;">{{ result | json }}</pre>
                </div>
            </div>
        </div>
    </div>
</div>
